import { createSystem, defaultConfig } from '@chakra-ui/react';

export const system = createSystem(defaultConfig, {
  theme: {
    tokens: {
      fonts: {
        heading: { value: `'Noto Sans', sans-serif` },
        body: { value: `'Noto Sans', sans-serif` },
      },
    },
  },
});
